__turbopack_context__.v({
  "container": "Vpod-module__PE7h3a__container",
  "containerOuterHidden": "Vpod-module__PE7h3a__containerOuterHidden",
});
